<section [ngSwitch]="bannerType">
  <ng-container *ngSwitchCase="type.ParentFloatingBanner">
    <section *ngFor="let product of productItems" class="banner-container">
      <h2
        *ngIf="leftTitleConfig?.view && product?.banners?.length"
        class="banner-title"
        [attr.data-cy]="'product-' + product?.name + '-text'"
      >
        {{ leftTitleConfig.principalText | translate }}
        <span>
          {{ leftTitleConfig?.secondaryText | translate }}
        </span>
      </h2>
      <section class="banner-blur-left">
        <section class="banner-section">
          <ion-card
            *ngFor="let banner of product?.banners"
            [ngClass]="{
              'full': product.bannerType === 'full',
              'two-across': product.bannerType === '50fifty',
              'three-across': product.bannerType === '3across',
              'four-across': product.bannerType === '4across',
              'five-across': product.bannerType === '5across',
              'six-across': product.bannerType === '6across'
            }"
            (click)="searchBannerProduct(banner, product.stickyGroupEnabled)"
            [attr.data-cy]="'product-banner-' + product?.bannerType + '-text'"
          >
            <img
              [src]="banner?.imageURL"
              (error)="getDefaultImage($event)"
              data-cy="product-banner-image"
            />
            <p data-cy="banner-img-text">
              {{ banner.slotName }}
            </p>
          </ion-card>
        </section>
      </section>
    </section>
  </ng-container>
</section>
